module.exports = __webpack_public_path__ + "img/abe.96c18bce.jpg";